import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'normal' | 'large' | 'small';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const cardWidth = size === 'large' ? 'w-48' : size === 'small' ? 'w-36' : 'w-44';
  const imgHeight = size === 'large' ? 'h-64' : size === 'small' ? 'h-48' : 'h-56';

  return (
    <Link
      to={`/article/${movie.id}`}
      className={`${cardWidth} group block cursor-pointer`}
      data-product-shop=""
    >
      {/* Cover Image */}
      <div className={`${imgHeight} relative rounded-lg overflow-hidden mb-2`}>
        <img
          src={movie.coverImage}
          alt={`${movie.title} - 草民影院免费在线观看`}
          title={`${movie.title} - 草民影院免费在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
          <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
              <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
            </div>
          </div>
        </div>
        {/* Rating Badge */}
        <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-accent-400 text-xs font-bold">
          {movie.rating}
        </div>
        {/* New / Hot Badge */}
        {(movie.isNew || movie.isHot) && (
          <div className="absolute top-2 left-2 flex flex-col gap-1">
            {movie.isNew && (
              <span className="px-2 py-0.5 rounded-md bg-primary-500 text-white text-xs font-medium">NEW</span>
            )}
            {movie.isHot && (
              <span className="px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-medium">热播</span>
            )}
          </div>
        )}
        {/* Episode Badge */}
        <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-white text-xs">
          {movie.updateEpisode}
        </div>
      </div>

      {/* Title */}
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
        {movie.title}
      </h3>

      {/* Meta */}
      {size !== 'small' && (
        <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
          <span>{movie.year}</span>
          <span>·</span>
          <span className="truncate">{movie.type}</span>
        </div>
      )}
    </Link>
  );
}